import ReconnectingWebSocket from 'reconnecting-websocket';

const fallbackLoginAppId = "2"; // process.env.REACT_APP_ENABLE_DEBUG ? "2-dev" : "2";
const fallbackInviteLinkAppId = "invite-dev";

// Instead, use LaunchDarkly flags. These functions expect a flags object (from useFlags):
export const getLoginAppId = (flags) => flags.loginAppId || fallbackLoginAppId;
export const getInviteLinkAppId = (flags) => flags.inviteLinkAppId || fallbackInviteLinkAppId;
export const getLinkPrefix = (flags) => flags.linkPrefix || "/v2";



export const fetchTicket = async (handleTicket, accountId, appContext, handleNeedsLogin, handleNoPhoneNumber, retryCount = 0) => {
  const MAX_RETRIES = 2;
  console.log("Fetching ticket for accountId:", accountId);
  try {
    const ticketResponse = await fetch(`https://${endpoint()}/zoom-phone/ticket/${accountId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Zoom-App-Context': appContext,
      }
    });

    console.log("Ticket response status:", ticketResponse.status);

    const ticketResponseJson = await ticketResponse.json();
    handleTicket(ticketResponseJson.ticket, 60 * 30 * 1000);
    if (ticketResponseJson.needs_login) {
      handleNeedsLogin(true);
    }
    if (ticketResponseJson.no_phone_number) {
      handleNoPhoneNumber(true);
    }
  } catch (error) {
    console.error('Error fetching ticket:', error);
    throw error;
  }
};

export const createWebSocket = (ticket, handlers) => {
  const url = `wss://${endpoint()}/zoom-phone/ws/${ticket}`;
  const ws = new ReconnectingWebSocket(url);

  ws.addEventListener('open', () => {
    console.log('WebSocket connected');
    handlers.onStatusChange('connected');
  });

  ws.addEventListener('close', (event) => {
    console.log('WebSocket closed with code:', event.code, 'reason:', event.reason);
    handlers.onStatusChange('disconnected');
  });

  ws.addEventListener('message', (event) => {
    console.log('Received webhook:');
    handlers.onMessage(event);
  });

  ws.addEventListener('error', (error) => {
    console.error('WebSocket error:', error);
    handlers.onStatusChange('error');
  });

  const disconnect = () => {
    ws.close();
  };

  return {
    disconnect,
    ws
  };
};


// const crypto = require("crypto-browserify");

//function to get the meeting number and passwork from the url
export function getMeetingNumberAndPasswordFromUrl(url) {
  const splitUrl = url.split('?')[0];

  if (!splitUrl) {
    return {
      meetingNumber: null,
      password: null
    };
  }

  const meetingNumber = splitUrl.substring(splitUrl.lastIndexOf('/') + 1);
  const queryString = url.split('?')[1];
  const password = queryString ? queryString.split('pwd=')[1] : null;

  return {
    meetingNumber,
    password
  };
}


const ALLOWED_WIRING_DOMAINS = ['.actual.video', '.polyguard.ai', 'localhost'];

function isAllowedWiringUrl(url) {
  try {
    const hostname = new URL(url).hostname;
    return ALLOWED_WIRING_DOMAINS.some(
      (d) => hostname === d || hostname.endsWith(d)
    );
  } catch {
    return false;
  }
}

function getWiringCookie(key) {
  const cookieName = key.toLowerCase();
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${cookieName}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export const endpoint = () => {

  // Check for wiring override cookie (set by launchpad preview links).
  // Cookie only — never query params, which would let an attacker craft a
  // link that redirects API traffic to a malicious server.
  try {
    const wiringUrl = getWiringCookie('WIRING_API_URL');
    if (wiringUrl && isAllowedWiringUrl(wiringUrl)) {
      return wiringUrl.replace(/^https?:\/\//, '');
    }
  } catch (e) {
    // Invalid wiring config, fall through to normal detection
  }

  // Check for env var override first
  if (process.env.REACT_APP_API_SERVER) {
    return process.env.REACT_APP_API_SERVER;
  }

  // Fallback: derive hostname from REACT_APP_API_ENDPOINT (set in .env,
  // which Honcho loads directly — unlike .env.development which depends
  // on craco-plugin-env mode detection that can fail via Turbo).
  if (process.env.REACT_APP_API_ENDPOINT) {
    try {
      return new URL(process.env.REACT_APP_API_ENDPOINT).host;
    } catch (e) {}
  }

  const STAGING_HOSTNAMES = "staging-ux.actual.video";
  const DEV_HOSTNAMES = ["ms-ux.actual.video", "local-ux.actual.video"];

  const url = new URL(window.location.href);
  const hostname = url.hostname;

  // NorthFlank resources are limited to 39 characters for subdomains
  const isDevHostname = DEV_HOSTNAMES.some(dev => hostname.includes(dev));
  if (hostname.includes(STAGING_HOSTNAMES) || isDevHostname) {
    const hostname_parts = hostname.split('.');
    const shortNameParts = hostname_parts[0].split('-');
    var shortName = "";
    while (shortName.length + shortNameParts[0].length + 1 < 39) {
      shortName += shortNameParts.shift();
      if (shortNameParts.length > 0) {
        shortName += '-';
      } else {
        break;
      }
    }
    shortName = shortName.replace(/-$/, '');
    // Remove -console suffix if present (console and API have different subdomain patterns)
    shortName = shortName.replace(/-console$/, '');
    return `${shortName}.${hostname_parts.slice(1).join('.').replace('-ux', '-api').replace('ms-', 'local-')}`;
  } else {
    return "api-global.polyguard.ai";
  }
}


export const envLabel = () => {
  const url = new URL(window.location.href);
  const hostname = url.hostname;
  if (hostname.includes(STAGING_HOSTNAMES)) {
    return { label: "STAGING", color: "brown", env: "staging" };
  } else if (hostname.includes(DEV_HOSTNAMES)) {
    return { label: "LOCAL DEV", color: "orange", env: "local" };
  }
  return { label: "", color: "green", env: "prod" };
}


export const fallbackCopyTextToClipboard = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return
    }
  } catch (err) {
  }

  var textArea = document.createElement("textarea");
  var activeElement = document.activeElement;
  textArea.value = text || "";
  textArea.setAttribute("readonly", "");
  textArea.setAttribute("aria-hidden", "true");

  // Keep the field selectable without affecting layout or scrolling.
  textArea.style.position = "fixed";
  textArea.style.top = "0";
  textArea.style.left = "-9999px";
  textArea.style.opacity = "0";
  textArea.style.pointerEvents = "none";
  textArea.style.fontSize = "16px";

  document.body.appendChild(textArea);
  textArea.focus({ preventScroll: true });
  textArea.select();
  textArea.setSelectionRange(0, textArea.value.length);

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  } finally {
    document.body.removeChild(textArea);
    if (activeElement && activeElement.focus) {
      activeElement.focus({ preventScroll: true });
    }
  }
}


export const fetchAccountLogs = async (accountId, appContext, paginationParams = {}) => {
  const { page = 1, pageSize = 10 } = paginationParams;
  const queryParams = new URLSearchParams({
    page,
    page_size: pageSize
  }).toString();
  const response = await fetch(`https://${endpoint()}/v2/logs/account/${accountId}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
    cache: 'no-store'
  });
  if (!response.ok) throw new Error(`Error fetching account logs: ${response.status}`);
  const data = await response.json();
  if (data.meetings && Array.isArray(data.meetings)) {
    data.meetings = data.meetings.map(record => {
      const meeting = record.meeting || {};
      const participant = record.participant || {};
      return {
        id: meeting.id || "unknown",
        meeting_uuid: meeting.uuid || "unknown",
        callType: "meeting",
        timestamp: meeting.start_time || "",
        start_time: meeting.start_time || "",
        title: meeting.topic || "Untitled Meeting",
        host_id: meeting.host_id || "",
        host_name: meeting.host_name || "",
        organization: "Polyguard",
        participant: participant,
        meeting: meeting,
        user_id: record.user_id,
        user_role: record.user_role
      };
    });
  }
  return data;
};

export const fetchAccountLogsWithSessionToken = async (accountId, sessionToken, paginationParams = {}) => {
  const { page = 1, pageSize = 10 } = paginationParams;
  const queryParams = new URLSearchParams({
    page,
    page_size: pageSize
  }).toString();
  const response = await fetch(`https://${endpoint()}/v2/logs/account/${accountId}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${sessionToken}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
    cache: 'no-store'
  });
  if (!response.ok) throw new Error(`Error fetching account logs: ${response.status}`);
  const data = await response.json();
  if (data.meetings && Array.isArray(data.meetings)) {
    data.meetings = data.meetings.map(record => {
      const meeting = record.meeting || {};
      const participant = record.participant || {};
      return {
        id: meeting.id || "unknown",
        meeting_uuid: meeting.uuid || "unknown",
        callType: "meeting",
        timestamp: meeting.start_time || "",
        start_time: meeting.start_time || "",
        title: meeting.topic || "Untitled Meeting",
        host_id: meeting.host_id || "",
        host_name: meeting.host_name || "",
        organization: "Polyguard",
        participant: participant,
        meeting: meeting,
        user_id: record.user_id,
        user_role: record.user_role
      };
    });
  }
  return data;
};

export const generateMeetingReport = async (meetingId, meetingUuid, appContext, polyUserId) => {
  try {
    const apiResponse = await fetch(`https://${endpoint()}/v2/reports/meeting`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        meeting_id: meetingId,
        meeting_uuid: meetingUuid,
        poly_user_id: polyUserId
      }),
    });

    if (!apiResponse.ok) {
      const errorText = await apiResponse.text();
      throw new Error(`Request failed: ${apiResponse.status}`);
    }

    const reportData = await apiResponse.json();

    if (!reportData.url) {
      throw new Error('No download URL returned');
    }

    return reportData;
  } catch (error) {
    console.error('Error generating meeting report:', error);
    throw error;
  }
};

export const fetchMeetingDetails = async (polyUserId, meetingId, meetingUuid, appContext, startTime) => {
  try {
    const response = await fetch(`https://${endpoint()}/v2/logs/meeting/details`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        meeting_id: meetingId,
        meeting_uuid: meetingUuid,
        start_time: startTime
      }),
      cache: 'no-store'
    });
    if (!response.ok) throw new Error(`Error fetching meeting details: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching meeting details:', error);
    throw error;
  }
};



export const maybeAddZoomAccountId = async (verificationJWT, zoomAccountId, appContext) => {
  try {
    console.log('Adding zoom account ID:', zoomAccountId);

    const jwtData = typeof verificationJWT === 'string' ? JSON.parse(verificationJWT) : verificationJWT;
    const polyUserId = jwtData.verification.sub

    if (!polyUserId) {
      throw new Error('Unable to extract user ID from verification JWT');
    }

    const response = await fetch(`https://${endpoint()}/zoom-phone/zoom-account/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Zoom-App-Context': appContext,
      },
      body: JSON.stringify({
        poly_user_id: polyUserId,
        zoom_account_id: zoomAccountId,
      })
    });

    const result = await response.json().catch(() => ({ message: 'Request completed' }));
    console.log('Add Zoom account operation:', result.message);
  } catch (error) {
    console.error('Error adding zoom account ID:', error);
  }
};
